export class ParametrosConsultaActivoFijoVisitante{
    public tipoDocumentoVisitante:string;
	public numeroDocumentoVisitante:string;
    public numeroSerial:string;
    
    constructor(){
        
    }
}